import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface ResGetAllSkillTree {
  message: string;
  result: [
    {
      CLUSTER_NODES: [
        _CLUSTER_NODE
      ]
      CREATE_BY: string;
      CREATE_DATE: Date;
      LINKS: [
        _LINK
      ]
      NODES: [
        _NODE
      ]
      NODES_SELECTION: {
        INFORMATIONEM: [
          _NODE_SELECTION
        ], SCIENTIA: [
          _NODE_SELECTION
        ], PREHENDERE: [
          _NODE_SELECTION
        ], SAPIENTIA: [
          _NODE_SELECTION
        ], PSYCHE: [
          _NODE_SELECTION
        ]
      }
      TEACHERS: [
        {
          TEACHER_ID: string;
          USERNAME: string;
        }
      ]
      TEACHER_ID: string;
      TREE_CLUSTER: string;
      TREE_ID: string;
      TREE_LINKS: string;
      TREE_NAME: string;
      TREE_NODES: string;
      VIEW_ONLY: boolean;
    }
  ]
  success: boolean;
}

interface _NODE_SELECTION {
  data: {
    customColor: string;
    color: string;
  }
  dimension: {
    width: number;
    height: number;
  }
  id: string;
  label: string;
  meta: { forceDimensions: false }
  position: {
    x: number;
    y: number;
  }
  tooltip: string;
}

interface _NODE {
  data: {
    color: string;
    customColor: string;
  }
  id: string;
  label: string;
  tooltip: string;
}

interface _LINK {
  data: {
    color: string;
    customColor: string;
  }
  id: string;
  source: string;
  target: string;
}

interface _CLUSTER_NODE {
  childNodeIds: []
  data: {
    color: string;
    customColor: string;
  }
  id: string;
}

@Injectable({
  providedIn: 'root'
})
export class SkillTreeService {
  token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getAllSkillTree() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetAllSkillTree>(environment.URL + '/skilltree/getAllSkillTree', { headers: headers });
  }

  getSkillTreeByCourse(id) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetAllSkillTree>(environment.URL + '/skilltree/getSkillTreeByCourse?COURSE_ID=' + id, { headers: headers });
  }

  getMySkillTree() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetAllSkillTree>(environment.URL + '/skilltree/getMySkillTree', { headers: headers });
  }

}
